module.exports = __webpack_public_path__ + "static/media/successIcon.16676e2c.svg";